<div *ngIf="isLoading" class="modal-body text-center py-5">
  <div class="mb-3">
    <div class="spinner-border text-primary" role="status"></div>
  </div>

  <h5 class="mb-1">Sertifikanız hazırlanıyor</h5>
  <p class="text-muted mb-0">Lütfen bekleyiniz...</p>
</div>

<div *ngIf="!isLoading">

  <div class="modal-header d-flex align-items-center justify-content-between">
    <h4 class="modal-title d-flex align-items-center gap-1">
      Sertifika Oluştur
    </h4>
    <button type="button" class="close" (click)="closeModal()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body text-center py-3">
    <div class="mb-2">
      <i data-feather="alert-circle" class="text-warning" style="width:40px;height:40px;"></i>
    </div>

    <p class="fs-5 mb-1">
      <strong>{{ calibration.certificateNo }}</strong> numaralı sertifikayı
    </p>
    <p class="text-muted mb-0">
      oluşturmak istediğinize emin misiniz?
    </p>
  </div>

  <div class="modal-footer d-flex justify-content-center gap-2">
    <button type="button" class="btn btn-outline-primary px-3" (click)="pdfDetail(false)" rippleEffect
      [disabled]="!measurementResultBase64">
      <i data-feather="eye" class="mr-25"></i>
      Önizle
    </button>

    <button type="button" class="btn btn-success px-3" (click)="pdfDetail(true)" rippleEffect
      [disabled]="!measurementResultBase64">
      <i data-feather="save" class="mr-25"></i>
      Kaydet
    </button>
  </div>
</div>